module.exports = __webpack_public_path__ + "static/media/addInventoryIcon.4df03844.svg";